import React from 'react';
import './Map.css';
import { useTranslation } from 'react-i18next';

const Map = () => {
  const { t } = useTranslation();

  return (
    <section className="map-section">
      <div className="container-fluid px-md-5 py-5 px-3">
        <h6 className="section-title text-center">{t('contact.title')}</h6>
        <h4 className="section-suptitle text-center text-white mb-4">
          {t('contact.map_desc')}
        </h4>

        <div className="map-container mb-5">
          <iframe
            title="Golden Fleece Factory Location"
            src="https://maps.google.com/maps?q=Yiwu%20Market,%20Jebel%20Ali,%20Dubai&t=&z=13&ie=UTF8&iwloc=&output=embed"
            loading="lazy"
            allowFullScreen
          ></iframe>
        </div>

        <div className="row align-items-center">
          <div className="col-md-4 mb-4 mb-md-0">
            <div className="d-flex gap-3 align-items-center">
              <img src="map-icon-1.png" alt="gmail" />
              <div>
                <h5 className="map-contact-main">{t('contact.gmail')}</h5>
                <h6 className="map-contact-sub">
                  <a
                    href={`mailto:${t('contact.email_value')}`}
                    rel="noreferrer"
                    className="text-white text-decoration-none"
                  >
                    {t('contact.email_value')}
                  </a>
                </h6>
              </div>
            </div>
          </div>

          <div className="col-md-4 mb-4 mb-md-0">
            <div className="d-flex gap-3 align-items-center">
              <img src="map-icon-2.png" alt="whatsapp" />
              <div>
                <h5 className="map-contact-main">{t('contact.whatsapp')}</h5>
                <h6 className="map-contact-sub">
                  <a
                    href="https://wa.me/971509590424"
                    target="_blank"
                    rel="noreferrer"
                    className="text-white text-decoration-none"
                  >
                    +971509590424
                  </a>
                </h6>
              </div>
            </div>
          </div>

          <div className="col-md-4">
            <div className="d-flex gap-3 align-items-center">
              <img src="map-icon-3.png" alt="location" />
              <div>
                <h5 className="map-contact-main">{t('contact.address')}</h5>
                <h6 className="map-contact-sub">
                  <a
                    href="https://www.google.com/maps/search/Yiwu+Market,+Jebel+Ali,+Dubai"
                    target="_blank"
                    rel="noreferrer"
                    className="text-white text-decoration-none"
                  >
                    {t('contact.actual_address')}
                  </a>
                </h6>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Map;
